import {
  canonicalPermissionCode,
  type AppModuleCode,
  type AuthUser,
  type PermissionCode,
} from '@gb-ticket/shared-types';

/** `/auth/me` sends canonical codes; legacy codes (pre-M4 session payloads) still match via alias. */
export function hasPermission(
  user: AuthUser | null | undefined,
  permission: PermissionCode,
): boolean {
  const required = canonicalPermissionCode(permission) ?? permission;
  return Boolean(user?.permissions.some((code) => canonicalPermissionCode(code) === required));
}

export function isModuleEnabled(user: AuthUser | null | undefined, code: AppModuleCode): boolean {
  return Boolean(user?.enabledModules.includes(code));
}
